import {Drawer, DrawerSection} from '@logistics-frontend/blocks/legacy'
import React from 'react'

import Content from '../../Content'
import {Props} from './types'

export function ModalMobile({onClose, contentSections}: Props): React.ReactElement<Props> {
  return (
    <Drawer onClose={onClose}>
      <DrawerSection>
        <Content sections={contentSections} />
      </DrawerSection>
    </Drawer>
  )
}
